import { Radio, H2 } from '@sbab-ui/components'
import { Suggestion } from '../../api/httpHandlers'
import SuggestionExplanation from './SuggestionExplanation'

interface Props {
  suggestion: Suggestion
  selected: boolean
  setSelectedSuggestion: (value: string) => void
}

function getTitle(suggestion: Suggestion) {
  if (suggestion.title === 'Installera solceller') return 'Solceller ' + suggestion.subtitle
  if (suggestion.title === 'Byt värmekälla') {
    if (suggestion.subtitle === 'Markvärmepump') return 'Bergvärme'
    if (suggestion.subtitle === 'Fjärrvärme') return 'Fjärrvärmecentral'
    return suggestion.subtitle
  }
  if (suggestion.title === 'Sänk temperaturen') return 'Sänk temperaturen 1 °C'
  if (suggestion.title === 'Tilläggsisolera väggar' || suggestion.title === 'Tilläggsisolera tak') return `${suggestion.title} ${suggestion.subtitle}`
  return suggestion.title
}

export default function SuggestionItem({
  suggestion,
  selected,
  setSelectedSuggestion,
}: Readonly<Props>) {
  function handleRadioChange(e: React.ChangeEvent<HTMLInputElement>) {
    setSelectedSuggestion(e.target.value)
  }

  if (suggestion.title === 'Byt värmekälla' && suggestion.subtitle === 'Fjärrvärme') {
    return null
  }

  const itemStyles = {
    border: '1px solid #999999',
    borderLeft: selected ? '4px solid #FF620F' : '4px solid #F2F2F2',
    cursor: 'pointer',
  }

  return (
    <div
      style={itemStyles}
      className="mb-4 flex h-16 w-full items-center justify-between px-4 lg:h-24"
      onClick={() => setSelectedSuggestion(suggestion.id)}
    >
      <Radio
        className="!m-0"
        label={
          <H2 className="!m-0 !ml-3 !text-base lg:!text-xl xl:!text-2xl">{getTitle(suggestion)}</H2>
        }
        value={suggestion.id}
        checked={selected}
        onChange={handleRadioChange}
        aria-label={`Spara energi: ${getTitle(suggestion)}`}
      />
      <SuggestionExplanation
        suggestion={suggestion}
        open={false}
        toggleOpen={() => {}}
        processedTitle={getTitle(suggestion)}
      />
    </div>
  )
}
